import { render, staticRenderFns } from "./FileReadView.vue?vue&type=template&id=117d1993&"
import script from "./FileReadView.vue?vue&type=script&lang=js&"
export * from "./FileReadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports